module.exports = __webpack_public_path__ + "img/no-yearly-team-rating.e6ac748d.webp";